import script from "./LocalStorage.vue?vue&type=script&lang=js"
export * from "./LocalStorage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__